import React from "react";
import styled from "styled-components";

import { Button } from "./Button";

export const WhiteButton = styled((props) => <Button {...props} />).attrs(
  (props) => ({
    automationid:
      props.automationid ||
      `SalesLead_button_${props?.automationidattr?.replace(/ /g, "")}_1"`,
  })
)`
  border: 1px solid #282828;
  color: #282828;
  background: white;
  &:hover {
    background: #eee;
  }
  &:disabled {
    background: #ebebeb;
    color: #cccccc;
    border: none;
  }
`;
